export const SUPPORTED_IN_STUDIO_TAG_ID =
  '352919c7-09f6-4640-8e9d-44cbc83d4d1e';
export const SUPPORTED_IN_EDITOR_X_TAG_ID =
  '1eea3456-e85a-4590-a053-09e3cd26e411';
